'use client'

import { useCallback, useMemo } from 'react'

import { isDevEnvironment } from '@common/helpers'

import { useLayoutStore } from '@stores/layout/layout.store'
import { selectUnreadNotificationCount } from '@stores/notifications/notifications.selector'
import { useNotificationsStore } from '@stores/notifications/notifications.store'

import { useLayoutNavigation } from './useLayoutNavigation'

type UseLayoutMobileMenuNavigationParams = {
  isPortal: boolean
  onNotificationClick?: () => void
}

export function useLayoutMobileMenuNavigation({ isPortal, onNotificationClick }: UseLayoutMobileMenuNavigationParams) {
  const closeMobileMenu = useLayoutStore((state) => state.closeMobileMenu)
  const navigation = useLayoutNavigation({ isPortal })
  const notificationsEnabled = isDevEnvironment()
  const unreadCount = useNotificationsStore(selectUnreadNotificationCount)
  const notificationBadge = notificationsEnabled ? unreadCount : undefined

  const handleNotificationClick = useCallback(() => {
    closeMobileMenu()
    onNotificationClick?.()
  }, [closeMobileMenu, onNotificationClick])

  return useMemo(
    () => ({
      ...navigation,
      notificationBadge,
      onNotificationClick: notificationsEnabled && onNotificationClick ? handleNotificationClick : undefined,
    }),
    [handleNotificationClick, navigation, notificationBadge, notificationsEnabled, onNotificationClick]
  )
}

export type LayoutMobileMenuNavigationValue = ReturnType<typeof useLayoutMobileMenuNavigation>
